var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileCreditsInner.jinja');
require('./MemberProfileCreditsInner.less');

var MemberProfileButtonsEdit = require('front/components/MemberProfileButtonsEdit/MemberProfileButtonsEdit');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileCreditsInner-contentItem--add': 'addCredit',
        'click .MemberProfileCreditsInner-contentItem-infoProdMembers': 'onProdMembersClick',
        'touchstart .MemberProfileCreditsInner-prodMembers': 'onTouchStart',
        'touchmove .MemberProfileCreditsInner-prodMembers': 'onTouchMove',
        'click .MemberProfileCreditsInner-prodMembers-delete': 'closeAllProdMembersPopups'
    },


    initialize: function (options) {
        var self = this;

        this.options = options || {};

        this.memberProdJsp = [];

        _.bindAll(this, 'onResize', 'addCredit', 'onBodyClick');

        this.MemberProfileButtonsEdit = new MemberProfileButtonsEdit({
            el: this.$el.parent().find('.MemberProfileButtonsEdit')[0]
        });


        if (!app.settings.isPhone) {
            this.$('.MemberProfileCreditsInner-contentItem-infoProdMembers .MemberProfileCreditsInner-prodMembersItems').each(function () {
                var item = $(this)
                    .jScrollPane()
                    .bind('mousewheel', function (e) {
                        e.preventDefault();
                    })
                    .data('jsp');

                self.memberProdJsp.push(item);
            });
        } else {
            this.$('.MemberProfileCreditsInner-prodMembersItems').each(function () {
                var $item = $(this);
                var contributorsCnt = $item.find('a').length;
                $item.css('height', (app.settings.isIE || app.settings.isEdge) ? 240 : contributorsCnt * 240 / window.app.settings.baseFontSize + 'rem');
            });
        }

        $(window).on('resize', this.onResize);
        this.onResize();

        Base.prototype.initialize.call(this, options);
    },


    onTouchStart: function (e) {
        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onTouchMove: function (e) {
        if (!app.settings.isPhone) return;

        var $scrollbox = $(e.currentTarget).find('.MemberProfileCreditsInner-prodMembersItems');

        var $target = $(e.target);
        var delta = this.popupScrollY - e.originalEvent.touches.item(0).clientY;

        if (!$target.closest($scrollbox).length) {
            e.preventDefault();
        }

        if ((delta < 0 && $scrollbox.scrollTop() <= 0) ||
            (delta > 0 && $scrollbox.scrollTop() + $scrollbox.outerHeight() >= $scrollbox[0].scrollHeight - 1)) { //-1 due to scaling float sizes
            e.preventDefault();
        }

        this.popupScrollY = e.originalEvent.touches.item(0).clientY;
    },


    onProdMembersClick: function (e) {
        if (app.settings.isDesktop) return;

        if ($(e.target).closest('.MemberProfileCreditsInner-prodMembers').length) return;

        if ($(e.currentTarget).hasClass('active')) {
            this.closeAllProdMembersPopups();
        } else {
            this.closeAllProdMembersPopups();
            $(e.currentTarget).addClass('active');
            $('body').on('click', this.onBodyClick);
        }
    },


    closeAllProdMembersPopups: function () {
        this.$('.MemberProfileCreditsInner-contentItem-infoProdMembers').removeClass('active');

        $('body').off('click', this.onBodyClick);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.MemberProfileCreditsInner-contentItem-infoProdMembers').length) return;

        this.closeAllProdMembersPopups();
    },


    onResize: function () {
        if (!app.settings.isPhone) {
            for (var i = 0; i < this.memberProdJsp.length; i++) {
                this.memberProdJsp[i].reinitialise();
            }
        }
    },


    deactivate: function (params) {
        this.MemberProfileButtonsEdit.deactivate();
        delete this.MemberProfileButtonsEdit;

        $(window).off('resize', this.onResize);

        return Base.prototype.deactivate.call(this, params);
    },


    addCredit: function () {
        window.app.vent.trigger('MemberProfileEdit--open', 'creditsAdd');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfileCreditsInner.js
// module id = 191
// module chunks = 0